var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:{double: _vm.double,triple: _vm.triple,operation: _vm.operation},on:{"click":function($event){return _vm.$emit('onClick',_vm.label)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }